import { RefObject, useEffect } from 'react';

export const usePrint = <T extends HTMLElement>(
  ref: RefObject<T>,
  forceUpdate: () => void
): void => {

  const beforePrint = () => {
    ref?.current?.classList.add('printing');
    forceUpdate();
  };

  const afterPrint = () => {
    ref?.current?.classList.remove('printing');
    forceUpdate();
  };

  useEffect(() => {
    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);

    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  }, []);
};
